import styled from 'styled-components';

// export const ChatHeaderContainer = styled.div`
//    background: ${(props) => props.$themecolor ?? '#3F5773'};
//    display: flex;
//    align-items: center;
//    justify-content: space-between;
//    width: 100%;
//    height: 40px;
//    padding: 10px 10px;
//  `;

// export const LeftWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   flex: 0.9;
// `;
//
// export const IconWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   //flex: 0.45;
//   flex: 0.47;
//   padding-right: 5px;
// `;
// export const TextWrapper = styled.div`
//   //flex: 0.55;
//   flex: 0.53;
//   color: #ffffff;
//   //font-size: ${(props) => (props.$device === 'pc' ? '16px' : '1rem')};
//   font-size: 16px;
// `;
//
// export const BackWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//
//   img {
//     width: 20px;
//     height: 20px;
//     margin-right: 6px;
//     cursor: pointer;
//   }
// `;
// export const LogoWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//
//   img {
//     height: 28px;
//   }
// `;
// export const RightWrapper = styled.div`
//   flex: 0.1;
//   display: flex;
//   align-items: center;
//   justify-content: flex-end;
//
//   img {
//     cursor: pointer;
//     width: 22px;
//     height: 22px;
//   }
//
//   img:first-child {
//     margin-right: 5px;
//   }
// `;

export const ChatHeaderContainer = styled.div`
  background: ${(props) => props.$themecolor ?? '#3F5773'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  padding: 10px 10px;
  box-sizing: border-box;
`;

export const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const ArrowIcon = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
    margin-right: 6px;
    cursor: pointer;
  }
`;

export const LogoIcon = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 100%;
    height: 28px;
  }
`;

export const CenterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  color: #ffffff;
  font-size: 16px;
  flex: 1;
`;

export const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  img {
    cursor: pointer;
    width: 22px;
    height: 22px;
  }
  img:first-child {
    margin-right: 5px;
  }
`;
export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  flex-direction: row;
  img {
    cursor: pointer;
    width: 22px;
    height: 22px;
    margin-left: 5px;
    margin-top: 2px;
  }
`;
